import { createSlice } from '@reduxjs/toolkit';
import EntriesFiltersData from 'modules/inbound/entries/domain/NextHours/EntriesFilters';
import { getEntriesST12Filters } from './async';

import { FiltersState } from './types';

export const initialState: FiltersState = {
  filters: EntriesFiltersData.generateEmpty(),
  requestStatus: ''
};
initialState.filters.warehouses = ['ST12'];
const EntriesST12FiltersSlice = createSlice({
  name: 'entriesST12Filters',
  initialState,
  reducers: {
    clearFilters: (state) => {
      state.filters = initialState.filters;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getEntriesST12Filters.fulfilled, (state, action) => {
      state.filters = action.payload;
      state.requestStatus = action.meta.requestStatus;
    });
    builder.addCase(getEntriesST12Filters.pending, (state, action) => {
      state.requestStatus = action.meta.requestStatus;
    });
    builder.addCase(getEntriesST12Filters.rejected, (state, action) => {
      state.requestStatus = action.meta.requestStatus;
    });
  }
});

export const getAllFilters = (state) => state.entriesST12FiltersState.filters;
export const { clearFilters } = EntriesST12FiltersSlice.actions;
export default EntriesST12FiltersSlice.reducer;
